<template>
    <a :href="whatsappLink" class="whatsapp-float" target="_blank" rel="noopener">
        <i class="fab fa-whatsapp"></i>
    </a>
</template>

<script>
export default {
    name: "WhatsappButton",
    props: {
        phone: {
            type: String,
            required: true
        },
        message: {
            type: String,
            default: ""
        }
    },
    computed: {
        whatsappLink() {
            const msg = encodeURIComponent(this.message);
            return `https://wa.me/${this.phone}?text=${msg}`;
        }
    }
};
</script>

<style scoped>
.whatsapp-float {
    position: fixed;
    width: 60px;
    height: 60px;
    bottom: 25px;
    right: 25px;
    background-color: #25d366;
    color: #FFF;
    border-radius: 50px;
    text-align: center;
    font-size: 32px;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
}

.whatsapp-float:hover {
    background-color: #1ebe5d;
}

.whatsapp-float {
  animation: pulse 2s infinite;
}

@media (max-width: 768px) {

  .whatsapp-float {
    width: 40px;
    height: 40px;
    font-size: 24px;
    bottom: 15px;
    right: 15px;
  }

}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}
</style>